var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('socialMedia',{class:{movedUp : _vm.newsMenuOpened}}),_c('newsMenu',{on:{"BarStatusChanged":_vm.barStatusChanged}}),(_vm.$isMobile())?_c('VFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }